/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BP } from "@adapptio/lib-blueprint";
import { createBlueprintSchema } from "./BlueprintBase";
import { DOC_TYPES } from "./DocTypes";

export const BlueprintDirectory = createBlueprintSchema(DOC_TYPES.DICTIONARY_V1, BP.Void({}));

export type TBlueprintDirectorySchema = typeof BlueprintDirectory;
